module.exports = __webpack_public_path__ + "img/tea.6440a152.gif";